/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Content, ListTable, Icon } from '@insticator/insticator-ui'; // iui-material
import ReportHelpers from 'pages/dashboard/reports/reporthelpers/reporthelpers';
import ReportControls from 'pages/dashboard/reports/reportcontrols/reportcontrols_container';
import data from 'pages/dashboard/reports/preview/data';
// utils
import { browserAlertOn, browserAlertOff, renderDayShort } from '@insticator/insticator-ui'; // iui-utils
import sortFunction from 'pages/dashboard/reports/preview/previewsortfunction';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/preview/preview_styles';



/* ========== ~~~~~~~~~~ REPORT PREVIEW ~~~~~~~~~~ ========== */
class PreviewPage extends Component {
	constructor(props) {
		super(props);

		this.columnHeads = {}; //Object.assign({}, Object.entries(data.data[0]).map(key => key[0]));
		this.rowData = this.props.previewData.data;
		this.totals = this.props.previewData.total;
        this.maxTotalExceeded = this.props.previewData.total.rows > 100;
		// populate column heads
		this.columnHeadsNames = {
			'SITE':'Site',
			'DEVICE':'Device',
			'GEO':'Country',
			'DATE':'Date',
			'AD_UNIT':'Ad Unit',
			'REVENUE':'Revenue',
			'IMPRESSION':'Impressions',
			'CPM':'CPM',
			'VIDEO_CPM':'Video CPM',
			'VIDEO_IMPRESSION':'Video Impressions',
			'VIDEO_REVENUE':'Video Revenue',
			'DISPLAY_CPM':'Display CPM',
			'DISPLAY_IMPRESSION':'Display Impressions',
			'DISPLAY_REVENUE':'Display Revenue'
		};
		this.state = {
			rowData: this.props.previewData.data,
			currentSortedColumn: ''
		};

        if(this.props.previewData.data.length) Object.keys(this.props.previewData.data[0]).forEach(key => {
        	this.columnHeads[key] = !!this.columnHeadsNames[key] ? this.columnHeadsNames[key] : key;
        });

		const dataToRemove = ['rows', 'dimensions'];

		const dimensions = this.totals.dimensions ? this.totals.dimensions : [];
		const metrics = Object.keys(this.totals).filter(key => !dataToRemove.includes(key)); // we should really reform this data structure so as to group metrics together properly instead of having them loose with other properties

		const metricsTotals = Object.assign({}, this.totals);
		dataToRemove.forEach(data => delete metricsTotals[data]);

		this.specialHeads = [
			{ colspan: dimensions.length, colcontent: `Dimensions` },
			{ colspan: metrics.length, colcontent: `Metrics` }
		];
		this.specialRow = [
			{ colspan: dimensions.length, colcontent: `Total (${this.totals.rows} rows)` },
			{ colspan: null, colcontent: metricsTotals }
		];
	}
	componentDidMount() {
		 if(!this.props.accountUUID || !this.props.isReportSaved) this.turnEditStateAlertsOn();
	}
	componentWillUnmount() {
		this.turnEditStateAlertsOff();
	}
	componentDidUpdate(prevProps) {
		if (!this.props.isReportSaved && prevProps.isReportSaved) 
			this.turnEditStateAlertsOn();
		else if (this.props.isReportSaved && !prevProps.isReportSaved)
	     	this.turnEditStateAlertsOff();
    }
	turnEditStateAlertsOn = () => {
        browserAlertOn();
        this.props.setEditMode(true);
    };
    turnEditStateAlertsOff = () => {
        browserAlertOff();
        this.props.setEditMode(false);
	};
	convertStringToReadableText = (key) => {
		return key.toLowerCase().replace('cpm', `CPM`).split('_').map(frag => frag.charAt(0).toUpperCase() + frag.slice(1)).join(' ');
	};

	renderDay = selectedDay => selectedDay ? renderDayShort(selectedDay) : '';

	displayDateRange = () => {
		return this.props.dateRange === 'CUSTOM' ? `${this.renderDay(this.props.customDateRange.from)} to ${this.renderDay(this.props.customDateRange.to)} ` : this.convertStringToReadableText(this.props.dateRange);
	};

	displayPreviewNotification = () => this.maxTotalExceeded ? `100 of ${Number(this.totals.rows).toLocaleString('en-US')} rows are displayed (and sorting is disabled). Download your report for full access.` : `${this.totals.rows} rows`

	handleColumnSort = (func, columnHead) => {
		const sorted = this.state.currentSortedColumn === columnHead ? '' : columnHead;
		this.setState({rowData: func(this.state.rowData, !!sorted), currentSortedColumn: sorted});
    };

    render() {
        return(
            <Page name={`preview`} klass={`${this.props.classes.preview}`}>
                <Content>
                	<ReportHelpers />
                	<div className={`previewhead`}>
                		<div className={`daterange`}>{this.displayDateRange()}</div>
						<div className={`previewnotification`} >{this.displayPreviewNotification()}</div>
					</div>
                    <ListTable
	                    name={`reportpreview`}
	                    variant={`slim`}
	                    type={'basic'}
	                    size={`full`}
	                    specialHeads={this.specialHeads}
	                    columnHeads={this.columnHeads}
						sortableHeads={this.props.previewData.total.rows <= 100 ? Object.keys(this.columnHeadsNames) : null}
						onSort={e => this.handleColumnSort(sortFunction(e), e)}
	                    specialRow={this.specialRow}
	                    specialRowPosition={`top`}
	                    data={this.state.rowData}
	                    message={this.maxTotalExceeded ? <p><Icon name={`exclamation-triangle`} color={`primary`} space={`right`} /> Previewing only the first 100 rows. Download the report for full access.</p> : null}
	                    showTitle={false}
	                    exportData={false}
	                    paginationLocation={`bottom`}
	                    rowsPerPage={100}
	                    moreDetails={false}
	                />
                </Content>
				<ReportControls variant={'preview'} />
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PreviewPage);
